import {connect} from 'react-redux';
import Step13 from './Step13';
import {submitStep} from "../../actions/submitStep";
import {uploadFile} from "../../actions/uploadFile";
import {prevCompletedStepSignFalse} from "../../actions/prevCompletedStepSign/prevCompletedStepSignFalse";

const mapStateToProps = ({
                           regType: {regType},
                           stepPayload: {payload},
                           locales: {current: language},
                           prevCompletedStepSign: {prevCompletedStepSign}
                         }) => ({
  regType,
  payload,
  language,
  prevCompletedStepSign
});

export default connect(
  mapStateToProps,
  {submitStep, uploadFile, prevCompletedStepSignFalse}
)(Step13);
